import { LocationMap } from "./components/LocationMap";

export default LocationMap